import { StyleSheet } from "react-native";
import { colors } from "@/app/constants/styles";

const KEY_SIZE = 70;
const KEY_GAP = 14;

export const numericKeypadStyles = StyleSheet.create({
  container: {
    gap: KEY_GAP,
  },
  row: {
    flexDirection: "row",
    gap: KEY_GAP,
  },
  key: {
    width: KEY_SIZE,
    height: KEY_SIZE,
    borderWidth: 1,
    borderColor: colors.albaikBrightRed,
    borderRadius: 4,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.white,
    shadowColor: colors.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 2,
  },
  emptyKey: {
    width: KEY_SIZE,
    height: KEY_SIZE,
  },
  keyText: {
    fontSize: 32,
    color: colors.albaikBrightRed,
  },
});

export const orderFieldStyles = StyleSheet.create({
  container: {
    gap: 8,
  },
  label: {
    fontSize: 12,
    letterSpacing: 1,
    color: colors.maroon,
  },
  required: {
    color: colors.albaikBrightRed,
  },
  inputRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  prefix: {
    height: 40,
    paddingHorizontal: 6,
    justifyContent: "center",
    backgroundColor: colors.dullWhite,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
  },
  prefixText: {
    fontSize: 14,
    color: colors.black,
  },
  input: {
    width: 110,
    height: 40,
    paddingHorizontal: 8,
    justifyContent: "center",
    borderWidth: 1,
    borderColor: colors.dullWhite,
    borderRadius: 4,
    backgroundColor: colors.white,
  },
  activeInput: {
    borderWidth: 2,
    borderColor: colors.albaikBrightRed,
  },
  valueText: {
    fontSize: 16,
    color: colors.maroon,
  },
});

export const headerStyles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    gap: 16,
    backgroundColor: colors.cardBackgroundWhite,
  },
  backButton: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 8,
    backgroundColor: colors.white,
  },
  backButtonText: {
    fontSize: 16,
    fontWeight: "500",
    color: colors.maroon,
  },
  title: {
    fontSize: 20,
    fontWeight: "500",
    color: colors.maroon,
  },
});

export const footerButtonStyles = StyleSheet.create({
  container: {
    alignItems: "center",
    paddingVertical: 16,
    backgroundColor: colors.beige,
  },
  button: {
    paddingHorizontal: 40,
    paddingVertical: 14,
    borderRadius: 4,
    backgroundColor: colors.albaikBrightRed,
  },
  disabledButton: {
    opacity: 0.5,
  },
  buttonText: {
    fontSize: 16,
    fontWeight: "500",
    color: colors.white,
  },
});
